function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 272,
  y1: -88.33,
  x2: 501.5,
  y2: -88.33,
  gradientTransform: "matrix(1, 0, 0, -1, -257, -48.5)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#202020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#202020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#202020",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 542.58,
  y1: -116.57,
  x2: 542.58,
  y2: -64.43,
  gradientTransform: "matrix(1, 0, 0, -1, -257, -48.5)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9a15c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ed9f2b"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  x: 289.48,
  y: 38.9,
  width: 13.79,
  height: 13.79,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  x: 267,
  y: 38.9,
  width: 13.79,
  height: 13.79,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 271.97,
  y: 26.48,
  width: 26.07,
  height: 26.07,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 328,
  height: 207,
  rx: 4,
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.6,14a1,1,0,1,1,.52,1.93l-3.86,1,1,3.86a1,1,0,1,1-1.93.52l-1-3.86-3.87,1a1,1,0,0,1-.52-1.93l3.87-1-1-3.86a1,1,0,0,1,.71-1.22,1,1,0,0,1,1.22.7l1,3.87Z",
  fill: "#f8f8f8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M66.89,105.82A8,8,0,1,0,64,94.89,8,8,0,0,0,66.89,105.82Zm1-1.73a6,6,0,1,0-2.2-8.2A6,6,0,0,0,67.89,104.09Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22,46.39a1,1,0,0,1-.84,1.46l-18.06.94a1,1,0,0,1-.91-1.49L12,30.24a1,1,0,0,1,1.75,0ZM12.8,32.83l6.67,13.1L4.79,46.7Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.92,80.16a1,1,0,1,1,.52,1.93l-3.86,1,1,3.86a1,1,0,1,1-1.93.52l-1-3.86-3.87,1a1,1,0,0,1-.51-1.93l3.86-1-1-3.86A1,1,0,0,1,20,77.33l1,3.87Z",
  fill: "#f8f8f8"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.85,184.9A8,8,0,1,0,22.92,174,8,8,0,0,0,25.85,184.9Zm1-1.73a6,6,0,1,0-2.2-8.2A6,6,0,0,0,26.85,183.17Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M85.37,127.63a7.83,7.83,0,0,0-8.79,7,8.18,8.18,0,0,0,6.69,9.25,7.83,7.83,0,0,0,8.79-7A8.18,8.18,0,0,0,85.37,127.63Zm-.26,2a5.88,5.88,0,0,0-6.56,5.26,6.14,6.14,0,0,0,5,7,5.86,5.86,0,0,0,6.55-5.26A6.12,6.12,0,0,0,85.11,129.62Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M139.15,151.66a1,1,0,0,1,.22-1.64l15.93-7.79a1,1,0,0,1,1.44,1.05l-2.58,19.91a1,1,0,0,1-1.65.59ZM152.42,161l-10.84-9.85,12.94-6.32Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M118,134.62a1,1,0,0,1-1.4-.2l0,0a1,1,0,0,1,.18-1.41l3.2-2.43-2.41-3.19a1,1,0,1,1,1.56-1.19l2.4,3.2,3.2-2.43a1,1,0,0,1,1.39.21l0,0a1,1,0,0,1-.18,1.4L122.75,131l2.4,3.19a1,1,0,0,1-.18,1.39,1,1,0,0,1-1.37-.2l-2.41-3.2Z",
  fill: "#f8f8f8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M77.66,37.72a7.83,7.83,0,0,0-8.79,7,8.18,8.18,0,0,0,6.69,9.25,7.83,7.83,0,0,0,8.8-7A8.18,8.18,0,0,0,77.66,37.72Zm-.25,2A5.88,5.88,0,0,0,70.85,45a6.13,6.13,0,0,0,5,7,5.88,5.88,0,0,0,6.56-5.27A6.14,6.14,0,0,0,77.41,39.7Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M304.09,78.39A8,8,0,0,0,312.47,86a7.94,7.94,0,0,0,7.38-8.53,8,8,0,0,0-8.38-7.64A7.94,7.94,0,0,0,304.09,78.39Zm2-.11A6,6,0,0,0,312.34,84a6,6,0,0,0,5.52-6.43,6,6,0,0,0-6.27-5.76A6,6,0,0,0,306.08,78.28Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M317,21.38a1,1,0,0,1-1.69.1L304.68,6.67a1,1,0,0,1,.75-1.58L324.86,4a1,1,0,0,1,.94,1.49ZM323.17,6.1,316,19,307.36,7Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M304.27,45.22a1,1,0,0,1,.08,1.38,1,1,0,0,1-1.37.08L300,44l-2.65,3a1,1,0,0,1-1.41.08l0,0a1,1,0,0,1-.09-1.42l2.66-3-3-2.67a1,1,0,1,1,1.29-1.46l3,2.67,2.65-3a1,1,0,0,1,1.41-.08l0,0a1,1,0,0,1,.08,1.42l-2.65,3Z",
  fill: "#f8f8f8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M217.41,103.53a8.05,8.05,0,0,0,8.38,7.64,7.94,7.94,0,0,0,7.39-8.53A8,8,0,0,0,224.8,95,8,8,0,0,0,217.41,103.53Zm2-.11a6,6,0,0,0,6.26,5.76,6,6,0,0,0,5.51-6.43A6,6,0,0,0,224.92,97,6,6,0,0,0,219.41,103.42Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M247.17,176.59a1,1,0,0,1-1.69.1l-10.66-14.81a1,1,0,0,1,.75-1.58L255,159.21a1,1,0,0,1,.93,1.49Zm6.15-15.28-7.14,12.93-8.67-12Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M234.74,21.27a1,1,0,0,1,.08,1.38,1,1,0,0,1-1.37.08l-3-2.67-2.65,3a1,1,0,0,1-1.41.08l0,0a1,1,0,0,1-.08-1.42l2.65-3L226,16a1,1,0,1,1,1.29-1.47l3,2.67,2.66-3a1,1,0,0,1,1.4-.08l0,0a1,1,0,0,1,.09,1.41l-2.66,3Z",
  fill: "#f8f8f8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M147.88,79.57a8.07,8.07,0,0,0,8.39,7.65,8,8,0,0,0,7.38-8.53A8.06,8.06,0,0,0,155.27,71,8,8,0,0,0,147.88,79.57Zm2-.11a6,6,0,0,0,6.26,5.76,6,6,0,0,0,5.51-6.42A6,6,0,0,0,155.39,73,6,6,0,0,0,149.88,79.46Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M153.36,25.28a1,1,0,0,1-1.48-.85L150.79,6.1a1,1,0,0,1,1.46-.92l16.94,9.7a1,1,0,0,1,0,1.76Zm13.3-9.56-12.89,7-.89-14.92Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M148.07,46.4a1,1,0,0,1,.08,1.39,1,1,0,0,1-1.38.08l-3-2.67-2.66,3a1,1,0,0,1-1.4.08l0,0a1,1,0,0,1-.09-1.41l2.66-3-3-2.67a1,1,0,0,1-.08-1.39,1,1,0,0,1,1.37-.08l3,2.67,2.65-3a1,1,0,0,1,1.41-.08l0,0a1,1,0,0,1,.09,1.41l-2.66,3Z",
  fill: "#f8f8f8"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M287.07,118a8.08,8.08,0,1,1-3.69,10.72A8,8,0,0,1,287.07,118Zm.86,1.81a6.08,6.08,0,1,1-2.74,8.05A6,6,0,0,1,287.93,119.85Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M308.7,178.94a1,1,0,0,0-1.52.72l-2.25,18.06a1,1,0,0,0,1.43,1L324,190.32a1,1,0,0,0,.11-1.76Zm.27,2.53-1.83,14.68,14.33-6.86Z",
  fill: "#f8f8f8",
  fillRule: "evenodd"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M309.39,151.54a1,1,0,0,0,.61,1.28l3.78,1.36L312.45,158a1,1,0,0,0,.6,1.26,1,1,0,0,0,1.24-.59l1.33-3.78,3.78,1.35a1,1,0,0,0,1.27-.61v0a1,1,0,0,0-.6-1.28l-3.78-1.35,1.33-3.78a1,1,0,0,0-.6-1.26,1,1,0,0,0-1.25.6l-1.33,3.78-3.77-1.35a1,1,0,0,0-1.28.61Z",
  fill: "#f8f8f8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M22.78,34.7v1.48H17.93v3.5h4v1.41h-4V46H16.1V34.7Zm3.94,4.21A3.42,3.42,0,0,1,28,37.55,3.63,3.63,0,0,1,29.92,37v2h-.54a3,3,0,0,0-1.94.6,2.31,2.31,0,0,0-.72,1.92V46H24.9V37.18h1.82Zm8.61-1.84a3.54,3.54,0,0,1,2.05.59,3.28,3.28,0,0,1,1.2,1.57v-2H40.4V46H38.58V44a3.24,3.24,0,0,1-1.2,1.57,3.54,3.54,0,0,1-2.05.59,4,4,0,0,1-2.07-.54A3.76,3.76,0,0,1,31.86,44a5.84,5.84,0,0,1,0-4.82,3.74,3.74,0,0,1,1.4-1.56A3.91,3.91,0,0,1,35.33,37.07Zm.56,1.6a2.53,2.53,0,0,0-2,.79,3,3,0,0,0-.72,2.12,3.05,3.05,0,0,0,.72,2.15,2.58,2.58,0,0,0,2,.77,2.62,2.62,0,0,0,1.37-.36,2.49,2.49,0,0,0,1-1,3.43,3.43,0,0,0,0-3.06,2.43,2.43,0,0,0-1-1A2.54,2.54,0,0,0,35.89,38.67ZM47,37.07a4.39,4.39,0,0,1,2.83.91,3.87,3.87,0,0,1,1.39,2.45H49.3a2,2,0,0,0-.79-1.29A2.37,2.37,0,0,0,47,38.66a2.31,2.31,0,0,0-1.76.75,3,3,0,0,0-.71,2.17,3.13,3.13,0,0,0,.71,2.2,2.31,2.31,0,0,0,1.76.75,2.37,2.37,0,0,0,1.53-.48,2.1,2.1,0,0,0,.79-1.31h1.93a3.92,3.92,0,0,1-1.39,2.46,4.33,4.33,0,0,1-2.83.91,4.65,4.65,0,0,1-2.27-.54A3.88,3.88,0,0,1,43.2,44a5.47,5.47,0,0,1,0-4.82,3.86,3.86,0,0,1,1.54-1.56A4.54,4.54,0,0,1,47,37.07Zm10.92,7.35V46H56.81a3.08,3.08,0,0,1-2.15-.67,3,3,0,0,1-.72-2.27V38.74H52.68V37.18h1.26V35h1.84v2.19h2.13v1.56H55.78v4.35a1.53,1.53,0,0,0,.27,1,1.42,1.42,0,0,0,1,.29Zm2-9.8a1,1,0,0,1,.32-.76,1.16,1.16,0,0,1,.85-.31,1.17,1.17,0,0,1,.85.31,1,1,0,0,1,0,1.52,1.25,1.25,0,0,1-.85.28,1.23,1.23,0,0,1-.85-.28A1,1,0,0,1,59.88,34.62ZM62,37.18V46H60.14V37.18Zm6.74-.11a4.74,4.74,0,0,1,2.3.55,3.82,3.82,0,0,1,1.6,1.56,5.3,5.3,0,0,1,0,4.82A3.84,3.84,0,0,1,71,45.57a4.85,4.85,0,0,1-2.3.54,4.92,4.92,0,0,1-2.31-.54A4.09,4.09,0,0,1,64.79,44a5,5,0,0,1-.57-2.42,4.89,4.89,0,0,1,.57-2.4,4.06,4.06,0,0,1,1.6-1.56A4.81,4.81,0,0,1,68.7,37.07Zm0,1.59a2.64,2.64,0,0,0-1.3.32,2.42,2.42,0,0,0-1,1,3.42,3.42,0,0,0-.35,1.61,3.52,3.52,0,0,0,.35,1.64,2.49,2.49,0,0,0,1,1,2.64,2.64,0,0,0,1.3.32A2.57,2.57,0,0,0,70,44.19a2.34,2.34,0,0,0,1-1,3.4,3.4,0,0,0,.37-1.64A3.3,3.3,0,0,0,70.94,40a2.28,2.28,0,0,0-1-1A2.57,2.57,0,0,0,68.7,38.66ZM80.36,37a3.2,3.2,0,0,1,2.46,1,4,4,0,0,1,.93,2.83V46H81.93V41.06a2.55,2.55,0,0,0-.61-1.83,2.15,2.15,0,0,0-1.66-.65,2.28,2.28,0,0,0-1.75.7,2.83,2.83,0,0,0-.65,2V46H75.43V37.18h1.83v1.94a3,3,0,0,1,1.18-1.54A3.43,3.43,0,0,1,80.36,37Zm8.92,0a3.68,3.68,0,0,1,2.48.8A3.26,3.26,0,0,1,92.91,40H91.18a1.8,1.8,0,0,0-.62-1.15,1.9,1.9,0,0,0-1.33-.45,1.6,1.6,0,0,0-1.07.34,1.12,1.12,0,0,0-.37.88.85.85,0,0,0,.28.67,1.79,1.79,0,0,0,.67.4A11.3,11.3,0,0,0,89.9,41a10.69,10.69,0,0,1,1.6.47,2.51,2.51,0,0,1,1.06.76A2.08,2.08,0,0,1,93,43.63a2.17,2.17,0,0,1-.85,1.79,3.41,3.41,0,0,1-2.26.69,4.31,4.31,0,0,1-2.67-.77A3.16,3.16,0,0,1,86,43.2h1.77a1.72,1.72,0,0,0,.64,1.17,2.3,2.3,0,0,0,1.47.45,1.5,1.5,0,0,0,1-.34,1.16,1.16,0,0,0,.38-.88,1,1,0,0,0-.28-.74,2,2,0,0,0-.72-.41,7.78,7.78,0,0,0-1.19-.32,13.9,13.9,0,0,1-1.57-.45,2.58,2.58,0,0,1-1-.72,2.11,2.11,0,0,1-.42-1.38,2.21,2.21,0,0,1,.84-1.8A3.52,3.52,0,0,1,89.28,37.07Zm13.84,0a3.51,3.51,0,0,1,2,.59,3.16,3.16,0,0,1,1.2,1.57v-2h1.83V46h-1.83V44a3.12,3.12,0,0,1-1.2,1.57,3.51,3.51,0,0,1-2,.59,4,4,0,0,1-2.06-.54A3.72,3.72,0,0,1,99.65,44a5.95,5.95,0,0,1,0-4.82,3.69,3.69,0,0,1,1.41-1.56A3.9,3.9,0,0,1,103.12,37.07Zm.56,1.6a2.53,2.53,0,0,0-2,.79,3,3,0,0,0-.72,2.12,3.05,3.05,0,0,0,.72,2.15,2.58,2.58,0,0,0,2,.77,2.66,2.66,0,0,0,1.38-.36,2.49,2.49,0,0,0,1-1,3.52,3.52,0,0,0,0-3.06,2.43,2.43,0,0,0-1-1A2.57,2.57,0,0,0,103.68,38.67ZM115.81,37a3.22,3.22,0,0,1,2.47,1,4,4,0,0,1,.93,2.83V46h-1.83V41.06a2.55,2.55,0,0,0-.61-1.83,2.13,2.13,0,0,0-1.66-.65,2.28,2.28,0,0,0-1.75.7,2.88,2.88,0,0,0-.65,2V46h-1.82V37.18h1.82v1.94a3,3,0,0,1,1.18-1.54A3.47,3.47,0,0,1,115.81,37Zm9.56,0a3.51,3.51,0,0,1,2,.59,3.14,3.14,0,0,1,1.19,1.57V34.16h1.84V46h-1.84V44a3.1,3.1,0,0,1-1.19,1.57,3.51,3.51,0,0,1-2,.59,4,4,0,0,1-2.06-.54A3.72,3.72,0,0,1,121.9,44a5.95,5.95,0,0,1,0-4.82,3.69,3.69,0,0,1,1.41-1.56A3.9,3.9,0,0,1,125.37,37.07Zm.56,1.6a2.53,2.53,0,0,0-2,.79,3,3,0,0,0-.72,2.12,3.05,3.05,0,0,0,.72,2.15,2.58,2.58,0,0,0,2,.77,2.66,2.66,0,0,0,1.38-.36,2.49,2.49,0,0,0,1-1,3.52,3.52,0,0,0,0-3.06,2.43,2.43,0,0,0-1-1A2.57,2.57,0,0,0,125.93,38.67Zm21.15,1.67a6.12,6.12,0,0,1-.7,3,4.83,4.83,0,0,1-2,2,6.74,6.74,0,0,1-3.19.7h-3.78V34.7h3.78a6.74,6.74,0,0,1,3.19.71,4.72,4.72,0,0,1,2,2A6,6,0,0,1,147.08,40.34Zm-6.06,4a4.33,4.33,0,0,0,3.12-1.05,4,4,0,0,0,1.09-3,4,4,0,0,0-1.09-3A4.29,4.29,0,0,0,141,36.32h-1.81v8Zm16.59-3.18a3.58,3.58,0,0,1-.07.78h-6.78a2.77,2.77,0,0,0,.75,2,2.72,2.72,0,0,0,3.28.19,1.92,1.92,0,0,0,.79-1.23h1.95a3.76,3.76,0,0,1-.74,1.65,3.9,3.9,0,0,1-1.45,1.13,4.83,4.83,0,0,1-2,.4,4.65,4.65,0,0,1-2.27-.54A3.82,3.82,0,0,1,149.53,44a5.47,5.47,0,0,1,0-4.82,3.8,3.8,0,0,1,1.54-1.56,4.54,4.54,0,0,1,2.27-.55,4.41,4.41,0,0,1,2.25.55,3.58,3.58,0,0,1,1.49,1.47A4.15,4.15,0,0,1,157.61,41.17Zm-1.84-.05a2.57,2.57,0,0,0-.31-1.44,2,2,0,0,0-.89-.86,2.54,2.54,0,0,0-1.23-.29,2.6,2.6,0,0,0-1.8.65,2.73,2.73,0,0,0-.78,1.94Zm8-4a4.37,4.37,0,0,1,2.83.91A3.87,3.87,0,0,1,168,40.43h-1.93a2,2,0,0,0-.79-1.29,2.37,2.37,0,0,0-1.53-.48,2.31,2.31,0,0,0-1.76.75,3,3,0,0,0-.71,2.17,3.13,3.13,0,0,0,.71,2.2,2.31,2.31,0,0,0,1.76.75,2.37,2.37,0,0,0,1.53-.48,2.1,2.1,0,0,0,.79-1.31H168a3.92,3.92,0,0,1-1.39,2.46,4.31,4.31,0,0,1-2.83.91,4.67,4.67,0,0,1-2.27-.54A3.88,3.88,0,0,1,160,44a5.47,5.47,0,0,1,0-4.82,3.86,3.86,0,0,1,1.54-1.56A4.57,4.57,0,0,1,163.79,37.07ZM170,34.62a1,1,0,0,1,.32-.76,1.16,1.16,0,0,1,.85-.31,1.17,1.17,0,0,1,.85.31,1,1,0,0,1,0,1.52,1.25,1.25,0,0,1-.85.28,1.23,1.23,0,0,1-.85-.28A1,1,0,0,1,170,34.62Zm2.08,2.56V46h-1.82V37.18ZM185.83,37a3.26,3.26,0,0,1,2.5,1,4,4,0,0,1,.94,2.83V46h-1.82V41.06a2.51,2.51,0,0,0-.58-1.78,2,2,0,0,0-1.58-.64,2.24,2.24,0,0,0-1.72.69,2.85,2.85,0,0,0-.62,2V46h-1.82V41.06a2.56,2.56,0,0,0-.58-1.78,2,2,0,0,0-1.58-.64,2.2,2.2,0,0,0-1.71.69,2.8,2.8,0,0,0-.63,2V46h-1.82V37.18h1.82V39a2.79,2.79,0,0,1,1.12-1.47,3.59,3.59,0,0,1,3.74,0,3.11,3.11,0,0,1,1.19,1.57,3.16,3.16,0,0,1,1.23-1.55A3.45,3.45,0,0,1,185.83,37Zm9.61,0a3.54,3.54,0,0,1,2.05.59,3.2,3.2,0,0,1,1.19,1.57v-2h1.83V46h-1.83V44a3.16,3.16,0,0,1-1.19,1.57,3.54,3.54,0,0,1-2.05.59,4,4,0,0,1-2.07-.54A3.85,3.85,0,0,1,192,44a5.95,5.95,0,0,1,0-4.82,3.82,3.82,0,0,1,1.41-1.56A3.91,3.91,0,0,1,195.44,37.07Zm.56,1.6a2.56,2.56,0,0,0-2,.79,3,3,0,0,0-.72,2.12,3.1,3.1,0,0,0,.72,2.15,2.84,2.84,0,0,0,3.33.41,2.49,2.49,0,0,0,1-1,3.52,3.52,0,0,0,0-3.06,2.43,2.43,0,0,0-1-1A2.54,2.54,0,0,0,196,38.67Zm9-4.51V46H203.2V34.16Zm5.6,2.91a3.66,3.66,0,0,1,2.48.8A3.32,3.32,0,0,1,214.26,40h-1.73a1.81,1.81,0,0,0-.63-1.15,1.89,1.89,0,0,0-1.32-.45,1.58,1.58,0,0,0-1.07.34,1.09,1.09,0,0,0-.37.88.87.87,0,0,0,.27.67,1.79,1.79,0,0,0,.67.4c.28.1.67.2,1.17.32a11.46,11.46,0,0,1,1.6.47,2.48,2.48,0,0,1,1.05.76,2.08,2.08,0,0,1,.45,1.41,2.19,2.19,0,0,1-.84,1.79,3.45,3.45,0,0,1-2.26.69,4.27,4.27,0,0,1-2.67-.77,3.13,3.13,0,0,1-1.22-2.14h1.78a1.65,1.65,0,0,0,.64,1.17,2.26,2.26,0,0,0,1.47.45,1.46,1.46,0,0,0,1-.34,1.13,1.13,0,0,0,.39-.88,1,1,0,0,0-.29-.74,1.81,1.81,0,0,0-.72-.41,7.47,7.47,0,0,0-1.19-.32,13.07,13.07,0,0,1-1.56-.45,2.54,2.54,0,0,1-1-.72,2.16,2.16,0,0,1-.41-1.38,2.2,2.2,0,0,1,.83-1.8A3.52,3.52,0,0,1,210.62,37.07Z",
  fill: "url(#linear-gradient)"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 85,
  width: 70,
  height: 24,
  rx: 4,
  fill: "#f9f9fa"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M29.71,102.64,28,100.93a4.62,4.62,0,0,1-1.23.17,4.18,4.18,0,0,1-2.13-.56A3.92,3.92,0,0,1,23.16,99a4.65,4.65,0,0,1-.54-2.25,4.57,4.57,0,0,1,.54-2.23A4,4,0,0,1,24.65,93a4.28,4.28,0,0,1,2.13-.55A4.19,4.19,0,0,1,28.9,93a3.94,3.94,0,0,1,1.48,1.55,4.57,4.57,0,0,1,.54,2.23A4.66,4.66,0,0,1,30.38,99a3.8,3.8,0,0,1-1.48,1.52l2.19,2.1Zm-6-5.88a3.93,3.93,0,0,0,.38,1.76,3,3,0,0,0,1.08,1.16,3.19,3.19,0,0,0,1.57.4,3,3,0,0,0,1.55-.41,2.73,2.73,0,0,0,1.08-1.15,3.69,3.69,0,0,0,.4-1.76,3.62,3.62,0,0,0-.4-1.75,2.62,2.62,0,0,0-1.08-1.15,3,3,0,0,0-1.55-.41,3.09,3.09,0,0,0-1.57.41A2.86,2.86,0,0,0,24.13,95,3.86,3.86,0,0,0,23.75,96.76Zm14.51-2.35V101h-1.1V99.45a2.16,2.16,0,0,1-.9,1.24,2.62,2.62,0,0,1-1.48.42,2.49,2.49,0,0,1-1.85-.73,3,3,0,0,1-.71-2.13V94.41h1.09v3.73a2.14,2.14,0,0,0,.51,1.53,1.79,1.79,0,0,0,1.36.53,1.9,1.9,0,0,0,1.44-.58,2.43,2.43,0,0,0,.54-1.7V94.41Zm1.55-1.93A.6.6,0,0,1,40,92a.73.73,0,0,1,.54-.19.76.76,0,0,1,.54.19.63.63,0,0,1,.2.48.66.66,0,0,1-.2.49.8.8,0,0,1-.54.18A.77.77,0,0,1,40,93,.64.64,0,0,1,39.81,92.48Zm1.29,1.93V101H40V94.41Zm2.39,5.67H47V101H42.29v-.88l3.36-4.78H42.38v-.93H46.9v.89Zm11.43-3.94v.92h-4.8v-.92Zm4.92.58a6.27,6.27,0,0,0,.67,3.18,3,3,0,0,0,4.66,0,7.73,7.73,0,0,0,0-6.34,3,3,0,0,0-4.66,0A6.16,6.16,0,0,0,59.84,96.72Zm4.93,0a8.64,8.64,0,0,1-.15,1.75,2.18,2.18,0,0,1-.57,1.11,1.94,1.94,0,0,1-2.41,0,2.27,2.27,0,0,1-.58-1.11,9.52,9.52,0,0,1-.14-1.75A9.21,9.21,0,0,1,61.06,95a2.23,2.23,0,0,1,.58-1.11,1.94,1.94,0,0,1,2.41,0A2.14,2.14,0,0,1,64.62,95,8.36,8.36,0,0,1,64.77,96.72Zm2.13,2.34v-.92l4.34-5.66h1.18v5.63h1.25v1H72.42V101h-1.1V99.06Zm4.49-5.25-3.34,4.3h3.34Z",
  fill: "#202020"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 99,
  y: 85,
  width: 70,
  height: 24,
  rx: 4,
  fill: "#f9f9fa"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M111.42,92.54v5.08a2.68,2.68,0,0,0,.55,1.84,2,2,0,0,0,1.53.59,1.91,1.91,0,0,0,1.5-.6,2.67,2.67,0,0,0,.54-1.83V92.54h1.09v5.08a3.57,3.57,0,0,1-.86,2.6,3.49,3.49,0,0,1-4.59,0,3.57,3.57,0,0,1-.85-2.6V92.54Zm10.37,1.76a2.43,2.43,0,0,1,1.86.75,2.93,2.93,0,0,1,.71,2.12V101h-1.09V97.27a2.07,2.07,0,0,0-.51-1.51,1.76,1.76,0,0,0-1.36-.53,1.82,1.82,0,0,0-1.44.59,2.37,2.37,0,0,0-.55,1.69V101h-1.09V94.41h1.09V96a2.26,2.26,0,0,1,.89-1.23A2.64,2.64,0,0,1,121.79,94.3Zm4-1.82a.6.6,0,0,1,.21-.48.73.73,0,0,1,.54-.19.76.76,0,0,1,.54.19.63.63,0,0,1,.2.48.66.66,0,0,1-.2.49.8.8,0,0,1-.54.18.77.77,0,0,1-.54-.18A.64.64,0,0,1,125.84,92.48Zm1.29,1.93V101H126V94.41ZM132,100v1h-.82a2.11,2.11,0,0,1-1.51-.48,2.18,2.18,0,0,1-.49-1.61V95.36h-1v-1h1V92.77h1.1v1.64H132v1h-1.7v3.58a1.28,1.28,0,0,0,.23.87,1.17,1.17,0,0,0,.81.23Zm8-3.9v.92h-4.8v-.92Zm4.92.58a6.27,6.27,0,0,0,.67,3.18,3,3,0,0,0,4.66,0,7.73,7.73,0,0,0,0-6.34,3,3,0,0,0-4.66,0A6.16,6.16,0,0,0,145,96.72Zm4.93,0a8.64,8.64,0,0,1-.15,1.75,2.18,2.18,0,0,1-.57,1.11,1.94,1.94,0,0,1-2.41,0,2.27,2.27,0,0,1-.58-1.11,9.52,9.52,0,0,1-.14-1.75,9.21,9.21,0,0,1,.14-1.73,2.23,2.23,0,0,1,.58-1.11,1.94,1.94,0,0,1,2.41,0,2.14,2.14,0,0,1,.57,1.11A8.36,8.36,0,0,1,149.92,96.72Zm2.26,3.44a18.22,18.22,0,0,0,3.27-2.71,4,4,0,0,0,1.22-2.52,1.67,1.67,0,0,0-.37-1.15,1.42,1.42,0,0,0-1.18-.45,1.53,1.53,0,0,0-1.27.54,2.43,2.43,0,0,0-.48,1.47h-1.08a3.16,3.16,0,0,1,.88-2.18,2.79,2.79,0,0,1,2-.76,2.69,2.69,0,0,1,1.88.63,2.35,2.35,0,0,1,.7,1.8,3.68,3.68,0,0,1-.63,2,8.52,8.52,0,0,1-1.55,1.83,11.81,11.81,0,0,1-1.9,1.43H158v.9h-5.82Z",
  fill: "#202020"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M0,162H328v41a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4Z",
  fill: "#f68a4e"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M125.64,187.91a3.07,3.07,0,0,1-.43,1.6,3.24,3.24,0,0,1-1.28,1.17,4.49,4.49,0,0,1-2.07.43,5.37,5.37,0,0,1-2.14-.4,3.75,3.75,0,0,1-1.52-1.18,3.43,3.43,0,0,1-.64-1.79H120a1.91,1.91,0,0,0,.54,1.15,1.78,1.78,0,0,0,1.27.45,1.46,1.46,0,0,0,1.07-.37,1.31,1.31,0,0,0,.38-1,1.23,1.23,0,0,0-.3-.86,2.1,2.1,0,0,0-.77-.56,13.09,13.09,0,0,0-1.28-.48,15.49,15.49,0,0,1-1.73-.69,3.44,3.44,0,0,1-1.15-1,2.88,2.88,0,0,1-.46-1.71,2.79,2.79,0,0,1,1-2.29,5,5,0,0,1,5.63,0,3.27,3.27,0,0,1,1.22,2.3H123a1.64,1.64,0,0,0-.51-1,1.53,1.53,0,0,0-1.13-.4,1.44,1.44,0,0,0-1,.34,1.13,1.13,0,0,0-.39.94,1.23,1.23,0,0,0,.29.83,2.31,2.31,0,0,0,.75.53,13.15,13.15,0,0,0,1.25.46,17.28,17.28,0,0,1,1.76.72,3.13,3.13,0,0,1,1.17,1A3,3,0,0,1,125.64,187.91Zm9.57-8.21v1.8h-3.12V191h-2.26v-9.5h-3.1v-1.8Zm8.34,9H139l-.8,2.27h-2.39L140,179.83h2.58L146.72,191h-2.38ZM143,187l-1.67-4.77L139.62,187Zm11.1,4-2.64-4.4h-1V191h-2.25V179.7h4.3a4.21,4.21,0,0,1,3,1,3.3,3.3,0,0,1,1,2.53,3.27,3.27,0,0,1-.72,2.15,3.49,3.49,0,0,1-2.05,1.15l2.82,4.51Zm-3.63-5.95h1.86c1.29,0,1.93-.57,1.93-1.71a1.65,1.65,0,0,0-.48-1.27,2,2,0,0,0-1.45-.46h-1.86Zm15.51-5.35v1.8h-3.12V191h-2.26v-9.5h-3.1v-1.8ZM180.68,191h-2.26l-5.06-7.68V191h-2.25V179.7h2.25l5.06,7.75V179.7h2.26Zm7.56-11.46a5.64,5.64,0,0,1,2.86.74,5.22,5.22,0,0,1,2,2.06,6.24,6.24,0,0,1,0,6,5.25,5.25,0,0,1-2,2.07,5.64,5.64,0,0,1-2.86.73,5.71,5.71,0,0,1-2.88-.73,5.46,5.46,0,0,1-2-2.07,6.39,6.39,0,0,1,0-6,5.43,5.43,0,0,1,2-2.06A5.72,5.72,0,0,1,188.24,179.54Zm0,2.08a3.38,3.38,0,0,0-1.75.45,3.11,3.11,0,0,0-1.18,1.3,4.25,4.25,0,0,0-.41,1.95,4.39,4.39,0,0,0,.41,2,3.18,3.18,0,0,0,1.18,1.28,3.38,3.38,0,0,0,1.75.45,3.32,3.32,0,0,0,1.74-.45,3.09,3.09,0,0,0,1.17-1.28,4.27,4.27,0,0,0,.43-2,4.13,4.13,0,0,0-.43-1.95,3,3,0,0,0-1.17-1.3A3.32,3.32,0,0,0,188.24,181.62Zm22.38-1.92L207.86,191h-2.79L203,182.81,200.83,191h-2.76l-2.77-11.3h2.44l1.73,8.76,2.24-8.76h2.48l2.26,8.76,1.73-8.76Z",
  fill: "#fff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M300,179l-1.41,1.41,4.58,4.59-4.58,4.59L300,191l6-6Z",
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M261,51l-5,2h8Z",
  fill: "#988989"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M310,51l5,2h-8Z",
  fill: "#988989"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M283.55,16.19a2.77,2.77,0,0,1,4.06,0l.18.18a2.77,2.77,0,0,0,3.41.52l.22-.13A2.78,2.78,0,0,1,295.3,18l.11.23a2.8,2.8,0,0,0,3.12,1.5l.24-.06a2.78,2.78,0,0,1,3.36,2.29l0,.25a2.77,2.77,0,0,0,2.53,2.35l.25,0a2.77,2.77,0,0,1,2.53,3.18l0,.24a2.77,2.77,0,0,0,1.72,3l.24.09a2.77,2.77,0,0,1,1.48,3.78l-.11.23a2.78,2.78,0,0,0,.77,3.37l.2.15a2.78,2.78,0,0,1,.3,4.06l-.17.18a2.77,2.77,0,0,0-.26,3.45l.15.2a2.79,2.79,0,0,1-.91,4l-.22.12a2.77,2.77,0,0,0-1.26,3.22l.07.24a2.77,2.77,0,0,1-2,3.52l-.24.05A2.78,2.78,0,0,0,305,60.3v.25a2.77,2.77,0,0,1-3,2.76l-.25,0a2.77,2.77,0,0,0-2.85,1.95l-.08.24a2.77,2.77,0,0,1-3.66,1.76l-.23-.09a2.77,2.77,0,0,0-3.3,1l-.15.21a2.76,2.76,0,0,1-4,.6l-.2-.15a2.77,2.77,0,0,0-3.46,0l-.19.15a2.77,2.77,0,0,1-4-.6l-.14-.21a2.77,2.77,0,0,0-3.3-1l-.24.09a2.77,2.77,0,0,1-3.66-1.76l-.07-.24a2.78,2.78,0,0,0-2.86-1.95l-.25,0a2.77,2.77,0,0,1-3-2.76V60.3A2.77,2.77,0,0,0,264,57.59l-.25-.05a2.77,2.77,0,0,1-2-3.52l.07-.24a2.77,2.77,0,0,0-1.26-3.22l-.22-.12a2.78,2.78,0,0,1-.9-4l.14-.2a2.77,2.77,0,0,0-.26-3.45l-.17-.18a2.78,2.78,0,0,1,.31-4.06l.19-.15a2.78,2.78,0,0,0,.77-3.37l-.11-.23a2.77,2.77,0,0,1,1.49-3.78L262,31a2.79,2.79,0,0,0,1.73-3l0-.24a2.77,2.77,0,0,1,2.53-3.18l.25,0A2.79,2.79,0,0,0,269,22.17l0-.25a2.77,2.77,0,0,1,3.35-2.29l.25.06a2.78,2.78,0,0,0,3.11-1.5l.11-.23a2.78,2.78,0,0,1,3.88-1.2l.22.13a2.78,2.78,0,0,0,3.42-.52Z",
  fill: "url(#linear-gradient-2)"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 285.55,
  cy: 42.66,
  r: 21.5,
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M294.85,45.55a.06.06,0,0,1,.06-.06h3.56a.06.06,0,0,1,.06.06V52a.06.06,0,0,1-.1,0l-1.71-1.12h-.07l-1.71,1.12a.06.06,0,0,1-.09,0Z",
  fill: "#3162ae"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 296.38,
  cy: 44.07,
  r: 4.6,
  fill: "#608bc7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.38,41.77l.52,1.59h1.67l-1.36,1,.52,1.59-1.35-1-1.35,1,.52-1.59-1.36-1h1.67Z",
  fill: "#fff"
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M272.36,45.55a.06.06,0,0,1,.06-.06H276a.06.06,0,0,1,.06.06V52a.06.06,0,0,1-.09,0l-1.71-1.12h-.07l-1.71,1.12a.06.06,0,0,1-.1,0Z",
  fill: "#3162ae"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 273.9,
  cy: 44.07,
  r: 4.6,
  fill: "#608bc7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.9,41.77l.51,1.59h1.67l-1.35,1,.52,1.59-1.35-1-1.35,1,.51-1.59-1.35-1h1.67Z",
  fill: "#fff"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M292,32.74H278.64V27.19H292Z",
  fill: "#2050a3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.92,29.91l6.63,11.48,4.81-2.78-6.72-11.42Z",
  fill: "#3470b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.9,29.35l6.63,11.48,3-1.72-6.68-11.45Z",
  fill: "#5291cd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.67,29.91,290,41.39l-4.81-2.78L292,27.19Z",
  fill: "#3470b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.69,29.35l-6.63,11.48-3-1.72,6.68-11.45Z",
  fill: "#5291cd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 285.28,
  cy: 44.14,
  r: 7.34,
  fill: "#ffd24a"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 285.28,
  cy: 44.14,
  r: 5.94,
  fill: "#ffd24a",
  stroke: "#f0b946",
  strokeWidth: 0.35
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.33,40.82l.8,2.48h2.6l-2.1,1.53.8,2.48-2.1-1.54-2.11,1.54.8-2.48-2.1-1.53h2.6Z",
  fill: "#f0b946"
}));

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M256,53h59l-3,6.5,3,6.5H256l3-6.5Z",
  fill: "#3fba8c"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M289,53H256l3,6.5L256,66h27Z",
  fill: "#33b885"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M269.37,57.39V59h1.95v.66h-1.95V61.3h2.18V62h-3V56.71h3v.68Zm4.44.43a1.67,1.67,0,0,1,1,.27,1.47,1.47,0,0,1,.56.74v-1h.86V62h-.86V61a1.47,1.47,0,0,1-.56.74,1.67,1.67,0,0,1-1,.27,1.87,1.87,0,0,1-1-.25,1.76,1.76,0,0,1-.66-.74,2.51,2.51,0,0,1-.24-1.13,2.44,2.44,0,0,1,.24-1.12,1.76,1.76,0,0,1,.66-.74A1.87,1.87,0,0,1,273.81,57.82Zm.26.75a1.2,1.2,0,0,0-.91.36,1.64,1.64,0,0,0,0,2,1.16,1.16,0,0,0,.91.36,1.28,1.28,0,0,0,.65-.16,1.23,1.23,0,0,0,.45-.48,1.5,1.5,0,0,0,.16-.72,1.46,1.46,0,0,0-.16-.71,1.16,1.16,0,0,0-.45-.48A1.19,1.19,0,0,0,274.07,58.57Zm3.77.11a1.54,1.54,0,0,1,.6-.64,1.68,1.68,0,0,1,.9-.24v.93h-.25a1.38,1.38,0,0,0-.91.28,1.1,1.1,0,0,0-.34.9V62H277V57.87h.85Zm4.23-.88a1.53,1.53,0,0,1,1.15.46,1.89,1.89,0,0,1,.44,1.33V62h-.86V59.68a1.18,1.18,0,0,0-.28-.85,1,1,0,0,0-.78-.31,1.08,1.08,0,0,0-.82.33,1.36,1.36,0,0,0-.31.95V62h-.85V57.87h.85v.91a1.32,1.32,0,0,1,.56-.72A1.61,1.61,0,0,1,282.07,57.8Zm8.18,4.2h-.86l-2.57-3.91V62H286V56.71h.85l2.57,3.93V56.71h.86Zm2.7-4.18a2.26,2.26,0,0,1,1.08.25,1.84,1.84,0,0,1,.75.74,2.21,2.21,0,0,1,.27,1.12,2.28,2.28,0,0,1-.27,1.13,1.84,1.84,0,0,1-.75.74,2.46,2.46,0,0,1-2.16,0,1.84,1.84,0,0,1-.75-.74,2.28,2.28,0,0,1-.27-1.13,2.21,2.21,0,0,1,.27-1.12,1.84,1.84,0,0,1,.75-.74A2.26,2.26,0,0,1,293,57.82Zm0,.74a1.28,1.28,0,0,0-.61.15,1.17,1.17,0,0,0-.45.46,1.61,1.61,0,0,0-.16.76,1.56,1.56,0,0,0,.16.76,1.17,1.17,0,0,0,.45.46,1.32,1.32,0,0,0,1.22,0,1.09,1.09,0,0,0,.44-.46,1.55,1.55,0,0,0,.17-.76,1.61,1.61,0,0,0-.17-.76,1.09,1.09,0,0,0-.44-.46A1.28,1.28,0,0,0,293,58.56Zm8.49-.69L300.29,62h-1l-1-3.19-1,3.19h-.94l-1.15-4.13h.87l.78,3.34,1-3.34h.9l1,3.34.79-3.34Z",
  fill: "#fff"
});

var SvgQuiz = function SvgQuiz(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 328 207",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuiz, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quiz.f1733147.svg";
export { ForwardRef as ReactComponent };